module.exports = __webpack_public_path__ + "img/logo-dog.f426523e.png";